module.exports = __webpack_public_path__ + "img/leadtributor-logo-text.0432bce6.png";